<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="status">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>


   
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>
<script>
import rerulesApi from '@/api/rerules.js';
export default {
  data() {
    return {
      form: {
        is_project: false,
        setting:[],
        status:false,
      },
      setting: [],
      loading: false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      rerulesApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          self.form = data.data.vars.values;
    
        })
        .catch(error => {});
    },
    addAchievement(){
      this.form.setting.push({
        id:1,
        text:"",//等级名称
        grade_id:0,//等级ID
        type:1,//1  返利对象  2  购买对象
        price:0,//返利金额
      });
    },
    delAchievement(index){
      this.form.setting.splice(index,1)
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      rerulesApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/rerules/setting/getSetting.vue